import ThemifyIconsContainer from "../../Components/Icons/ThemifyIcons/ThemifyIcons"

const ThemifyIcons = () => {
  return (
    <div className='page-body'>
      <ThemifyIconsContainer />
    </div>
  )
}

export default ThemifyIcons